import React from 'react';
import MuiMenu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  paper: {
    marginTop: '20px',
    boxShadow: `${theme.shadows[2]} !important`,
  },
  list: {
    border: 'none !important',
    borderRadius: '0.375rem !important',
    paddingBottom: '0.5rem',
    paddingTop: '0.5rem',
    maxHeight: '20rem',
  },
});


const Menu = (props) => {
  const {
    classes, id, open,
    onClose, anchorEl,
  } = props;

  return (
    <MuiMenu
      {...props}
      disableEnforceFocus
      keepMounted
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.paper,
        list: classes.list,
      }}
    >
      {props.children}
    </MuiMenu>
  );
};

Menu.propTypes = {
  id: PropTypes.string,
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({}).isRequired,
  anchorEl: PropTypes.element.isRequired,
  handleClose: PropTypes.func.isRequired,
};

Menu.defaultProps = {
  id: '',
};

export default withStyles(styles)(Menu);
